import env from '@/env';
import { apiFetch } from '@/core';
import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';

export const printMDRLocations = async ({
  visitId,
  certificateId,
  type,
}: {
  visitId: string;
  certificateId: string;
  type: 'DN150' | 'DN150E' | 'Table';
}) => {
  const url =
    type !== 'Table'
      ? `${env.VITE_API_URL}/pb/s/api/sqo-portal/auditor-visits/${visitId}/${certificateId}/export-mdr-prods-into-excel?type=${type}`
      : `${env.VITE_API_URL}/pb/s/api/sqo-portal/auditor-visits/${visitId}/${certificateId}/export-mdr-prods-into-excel`;

  try {
    const response = await apiFetch(url, { method: 'GET' });
    if (!response.ok) {
      const error = (await response.json()) as ErrorResponseDto;
      throw new ApiError(error);
    }
    const resp = (await response.json()) as unknown as {
      url: string;
    };
    const link = document.createElement('a');

    link.href = resp.url;
    link.download = `mdr_${new Date().toISOString().slice(0, 10)}.xlsx`;

    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    throw error;
  }
};
